import { useOutOfDatePoller } from './useOutOfDatePoller.js';

export const OutOfDateNotifier = () => {
  useOutOfDatePoller();
  return null;
};
